<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>

<div class="page-wrapper">
  <div class="header"></div>

  <div class="content-wrapper">
    <div class="region-title-holder">
      <div class="region">
        <img [src]="regionData.iconUrl" alt="Region Icon" />
        <p class="region-name">{{ regionData.regionName }} region</p>
      </div>

      <fd-search-field
        (valueSelect)="addChipToCollection($event)"
        [options]="regionData.countries"
      >
      </fd-search-field>
    </div>

    <div class="chips-wrapper">
      <fd-chip-collection [backgroundColor]="'white'" [isFiltersRemoved]="isCountryFilterRemoved" (removeChipOutput)="filterByCountry()"> </fd-chip-collection>
      <div
        [@fade]
        class="filter-button-wrapper"
        *ngIf="
          (this.fdChipCollectionComponent?.chips)!.length > 0 ? true : false
        "
      >
        <button mat-flat-button (click)="filterByCountry()">
          {{ textConstants.FILTER_BUTTON_TEXT }}
        </button>
      </div>
    </div>

    <app-mecs-kpi-filter
      [isFiltersRemoved]="isKpiFilterRemoved"
      (filter)="getFilterData($event)"
    ></app-mecs-kpi-filter>

    <div class="dashboard-data-holder">
      <div class="information-holder">
        <div class="information-left-section-holder">
          <app-mecs-implementation-status
            [subheading]="'Global view'"
            [data]="countriesData.implementationStatus"
          ></app-mecs-implementation-status>
        </div>

        <div class="information-right-section-holder">
          <div class="global-overview">
            <div class="title-pagination">
              <p class="heading">Regional overview</p>

              <div class="pagination" *ngIf="totalPagesGlobalOverview > 1">
                <span
                  class="arrow"
                  (click)="
                    goToPageGlobalOverivew(currentPageGlobalOverview - 1)
                  "
                  [class.disabled]="currentPageGlobalOverview === 1"
                  >&#x276E;</span
                >

                <span
                  *ngFor="let page of pagesGlobalOverview"
                  class="page-number"
                  [class.active]="page === currentPageGlobalOverview"
                  (click)="goToPageGlobalOverivew(page)"
                  >{{ page }}</span
                >

                <span
                  class="arrow"
                  (click)="
                    goToPageGlobalOverivew(currentPageGlobalOverview + 1)
                  "
                  [class.disabled]="
                    currentPageGlobalOverview === totalPagesGlobalOverview
                  "
                  >&#x276F;</span
                >
              </div>
            </div>

            <empty-state
              class="table-holder"
              *ngIf="countriesData.globalOverview.length === 0"
            ></empty-state>

            <div class="overview-holder">
              <div
                class="overivew-box"
                *ngFor="let item of paginatedGlobalOverview"
              >
                <div class="counter-information">
                  <div class="counter">{{ item.numberOfUserCountries }}</div>
                  <div class="information">
                    Current total # countries that have launched
                  </div>
                </div>
                <div class="project-information">{{ item.projectName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="phase-table-wrapper">
      <div class="title-pagination">
        <p class="heading">Overview of solutions by their launch phase</p>
      </div>

      <div class="phase-table-holder">
        <div class="column" *ngFor="let phase of solutionPhaseData">
          <div class="phase-name" [style.background-color]="phase.color">{{ phase.phase }}</div>
          <div class="card-holder" *ngFor="let country of phase.countries">
            <div class="side-color"  [style.background-color]="country.color"></div>
            <div class="card">
              <div class="country">{{ country.countryName }}</div>
              <div class="tags">
                <span class="tag" *ngFor="let solution of country.solutions">{{
                  solution
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
